// 采购类型
const PURCHASE_TYPE = [
  {
    id: 1,
    name: "货物",
    tip: "指各种形态和种类的物品，包括原材料、燃料、设备、产品等",
  },
  {
    id: 3,
    name: "服务",
    tip: "指除货物和工程以外的其他政府采购对象，包含了工程相关的勘察、设计、监理等服务采购",
  },
  {
    id: 2,
    name: "工程",
    tip: "指建设工程，包括建筑物和构筑物的新建、改建、扩建、装修、拆除、修缮等",
  },
];

// 采购单位
const PURCHASING_UNIT = [
  {
    text: "医疗",
    id: 1,
    tip: "包含医院、急救中心、政府医疗单位等医疗相关采购单位",
    children: [
      { id: 8, text: "医院" },
      { id: 9, text: "急救中心" },
      { id: 10, text: "疾控中心" },
      { id: 11, text: "疗养院" },
      { id: 12, text: "卫生院" },
      { id: 13, text: "诊所" },
      { id: 14, text: "血站" },
    ],
  },
  {
    text: "学校",
    id: 3,
    tip: "包含大学、中学、小学、幼儿园等各阶段学校，以及教育局等政府教育单位",
    children: [
      { id: 15, text: "大学" },
      { id: 16, text: "中学" },
      { id: 17, text: "小学" },
      { id: 18, text: "幼儿园" },
      { id: 19, text: "培训学校" },
      { id: 20, text: "其他学校" },
    ],
  },
  {
    text: "政府",
    id: 2,
    tip: "包含政府机关、党组织、人大、政协等各类各级别采购单位",
    children: [
      {
        id: 21,
        text: "消防",
      },
      {
        id: 22,
        text: "交警",
      },
      {
        id: 23,
        text: "文化和旅游",
      },
      {
        id: 24,
        text: "检法司",
      },
      {
        id: 25,
        text: "人大／政协",
      },
      {
        id: 26,
        text: "纪委",
      },
      {
        id: 27,
        text: "监狱",
      },
      {
        id: 28,
        text: "博物馆",
      },
      {
        id: 29,
        text: "审计局",
      },
      {
        id: 30,
        text: "税务",
      },
      {
        id: 31,
        text: "财政",
      },
      {
        id: 32,
        text: "设计勘察院",
      },
      {
        id: 33,
        text: "宣传",
      },
      {
        id: 34,
        text: "市场监督",
      },
      {
        id: 35,
        text: "地方政务",
      },
      {
        id: 36,
        text: "市政",
      },
      {
        id: 37,
        text: "组织",
      },
      {
        id: 38,
        text: "住房和城乡建设",
      },
      {
        id: 39,
        text: "城市管理",
      },
      {
        id: 40,
        text: "教育",
      },
      {
        id: 41,
        text: "医疗",
      },
      {
        id: 42,
        text: "民政",
      },
      {
        id: 43,
        text: "敬老／福利院",
      },
      {
        id: 44,
        text: "殡葬",
      },
      {
        id: 45,
        text: "供电局",
      },
      {
        id: 46,
        text: "戒毒所",
      },
      {
        id: 47,
        text: "气象",
      },
      {
        id: 48,
        text: "国资委",
      },
      {
        id: 49,
        text: "海关",
      },
      {
        id: 50,
        text: "彩票",
      },
      {
        id: 51,
        text: "工会",
      },
      {
        id: 52,
        text: "水利水电",
      },
      {
        id: 53,
        text: "交通运输",
      },
      {
        id: 54,
        text: "民族事务",
      },
      {
        id: 55,
        text: "统计局",
      },
      {
        id: 56,
        text: "统战",
      },
      {
        id: 57,
        text: "自然资源",
      },
      {
        id: 58,
        text: "农业农村",
      },
    ],
  },
  { text: "公安", id: 4, tip: "包含公安系统的各级别采购单位", children: [] },
  {
    text: "金融企业",
    id: 5,
    tip: "包含银行、证券、保险等金融相关企业",
    children: [
      { id: 29, text: "银行" },
      { id: 30, text: "证券" },
      { id: 31, text: "保险" },
      { id: 32, text: "信托" },
      { id: 33, text: "金融合作社" },
      { id: 34, text: "投资融资" },
      { id: 35, text: "商务服务" },
    ],
  },
  {
    text: "部队",
    id: 6,
    tip: "包含武装部、军分区、部队等国防相关采购单位",
    children: [{ id: 36, text: "国防" }],
  },
  {
    text: "通信运营商",
    id: 7,
    tip: "移动、电信、联通以及相关运营商采购单位",
    children: [{ id: 37, text: "运营商" }],
  },
];

// 阶段
const STAGE_TYPE = [
  {
    name: "招标",
    children: [0, 1, 2, 3, 99],
  },
];

export const DICTIONARY = {
  PURCHASE_TYPE,
  PURCHASING_UNIT,
  STAGE_TYPE,
};
